import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-send-password',
  templateUrl: 'send-password.html',
})
export class SendPasswordPage {

  username: string;
  data = {
    "background": "assets/images/background/26.jpg"
  };

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private loginprovider: LoginProvider,
    private toast: ToastProvider) {
  }

  sendPassword(){
    this.loginprovider.sendTenantPassword(this.username).then(val => {
      this.toast.presentToast(val.message);
      if(val.status == "success"){
        this.navCtrl.pop();
      }
    }).catch(err => {
      console.log(err);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SendPasswordPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/send-password/send-password.ts